module.exports = __webpack_public_path__ + "img/set-item1.759356d2.png";